import styled from "styled-components";
import { GrayColors } from "@smartsuite/types";

export const StyledReadOnlySection = styled.div`
  padding: 6px 11px;
  border: 1px solid ${GrayColors["G-1-5"]};
  border-radius: 5px;
  display: flex;
  min-height: 36px;
  cursor: pointer;

  div {
    display: flex;
    align-items: center;
    min-width: 0;

    * {
      display: flex;
    }

    svg {
      margin-right: 15px;
    }

    span {
      margin-right: 13px;
    }

    span:first-of-type {
      display: block;
      min-width: 0;
    }
  }
`;
